import { Controller } from "@hotwired/stimulus"

// When gig_experience is "none" (never played live), force booking_expectation
// to "representation" and disable the other options.
export default class extends Controller {
  static targets = ["bookingContainer", "infoText"]
  static values = { forcedValue: { type: String, default: "representation" } }

  connect() {
    this.update()
  }

  update() {
    const noneSelected = this.element.querySelector(
      'input[name*="[gig_experience]"][value="none"]:checked'
    )

    if (noneSelected) {
      this.lockToForced()
    } else {
      this.unlockAll()
    }
  }

  lockToForced() {
    const labels = this.bookingContainerTarget.querySelectorAll("label")

    labels.forEach((label) => {
      const radio = label.querySelector('input[type="radio"]')
      if (!radio) return

      if (radio.value === this.forcedValueValue) {
        radio.checked = true
        radio.disabled = false
        label.classList.remove("opacity-50", "cursor-not-allowed", "pointer-events-none")
      } else {
        radio.checked = false
        radio.disabled = true
        label.classList.add("opacity-50", "cursor-not-allowed", "pointer-events-none")
      }
    })

    this.infoTextTarget.classList.remove("hidden")
  }

  unlockAll() {
    const labels = this.bookingContainerTarget.querySelectorAll("label")

    labels.forEach((label) => {
      const radio = label.querySelector('input[type="radio"]')
      if (!radio) return

      radio.disabled = false
      label.classList.remove("opacity-50", "cursor-not-allowed", "pointer-events-none")
    })

    this.infoTextTarget.classList.add("hidden")
  }
}
